import { ColWidth } from "@/constants/common.constant";
import { TableHeaderConfig } from "@/interfaces/common.interface";

export const tableConfig: TableHeaderConfig[] = [
  {
    prop: "accountId",
    label: "アカウントID",
    width: ColWidth.md,
  },
  {
    prop: "tantoCd",
    label: "担当者コード",
    width: ColWidth.md,
  },
  {
    prop: "tantoNm",
    label: "担当者名",
  },
  {
    prop: "kengen",
    label: "権限",
    width: ColWidth.sm,
  },
  {
    prop: "createdDate",
    label: "登録日時",
    width: ColWidth.lg,
  },
  {
    prop: "updatedDate",
    label: "更新日時",
    width: ColWidth.lg,
  },
];
